// extracted by mini-css-extract-plugin
export default {"border_color":"style_border_color__dBUBB","cursor_pointer":"style_cursor_pointer__eeUEL","reviews":"style_reviews__iWXNS","scrollbar_custom":"style_scrollbar_custom__tts13"};